import { createFileRoute } from '@tanstack/react-router';

import { AccountSectionsPage } from '../features/account/account-sections-page.js';

export const Route = createFileRoute('/_authed/account/')({
  component: AccountSectionsPage,
});
